import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/PartSearchAppraisal'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class PartSearchAppraisalStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "PartSearchAppraisalStore",
			variables: true,
		})
	}
}

export async function load_PartSearchAppraisal(params) {
  await initClient()

	const store = new PartSearchAppraisalStore()

	await store.fetch(params)

	return {
		PartSearchAppraisal: store,
	}
}
